import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet-rotatedmarker";

// Fix default marker icon issue
import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import FlightIcon from "../../assets/flight.png";

const DefaultIcon = L.icon({
  iconUrl,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const PlaneIcon = L.icon({
  iconUrl: FlightIcon,
  iconSize: [40, 40],
  iconAnchor: [20, 20],
});

L.Marker.prototype.options.icon = DefaultIcon;

export default function FlightMap({
  airports = [],
  currentFlightPosition = [],
  heading = 0,
}) {
  // console.log(airports);

  // Filter valid coordinates
  const validAirports = airports.filter(
    (a) => a?.latitude && a?.longitude
  );

  // Create polyline positions safely
  const polylinePositions = validAirports.map((a) => [
    a.latitude,
    a.longitude,
  ]);

  // Merge first + last safely
  const merge = [
    validAirports.at(-1),
    validAirports[0],
  ].filter((a) => a); // remove null

  // console.log(currentFlightPosition);

  // Flight polyline (valid only)
  const currentFlightPolyline = currentFlightPosition
    .filter((p) => p?.lat && p?.lon)
    .map((p) => [p.lat, p.lon]);

  function FitMapBounds({ positions }) {
    const map = useMap();
    useEffect(() => {
      if (positions.length > 0) {
        map.fitBounds(positions);
      }
    }, [positions]);
    return null;
  }

  const [showBounds, setShowBounds] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => setShowBounds(false), 3000);
    return () => clearTimeout(timeout);
  }, []);

  // Safe default center
  const mapCenter =
    polylinePositions.length > 0 ? polylinePositions.at(-1) : [20, 78]; // India center fallback

  return (
    <MapContainer
      center={mapCenter}
      zoom={4}
      className="map-container"
    >
      <TileLayer
        url={`https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}`}
        attribution='&copy; <a href="https://maps.google.com">Google Maps</a>'
      />

      {/* Main Flight Route */}
      {polylinePositions.length > 0 && (
        <Polyline
          positions={polylinePositions}
          color="#ddd"
          weight={3}
          dashArray="4, 6"
        />
      )}

      {/* Live flight trail */}
      {currentFlightPolyline.length > 0 && (
        <Polyline
          positions={currentFlightPolyline}
          color="red"
          weight={3}
        />
      )}

      {/* Start + End Markers */}
      {merge.map((airport, idx) => (
        <Marker
          key={idx}
          position={[airport.latitude, airport.longitude]}
        >
          <Popup>{airport.name}</Popup>
        </Marker>
      ))}

      {/* Current Flight Position */}
      {currentFlightPosition?.[0]?.lat &&
        currentFlightPosition?.[0]?.lon && (
          <Marker
            position={[
              currentFlightPosition[0].lat,
              currentFlightPosition[0].lon,
            ]}
            icon={PlaneIcon}
            rotationAngle={heading}
            rotationOrigin="center"
          ></Marker>
        )}

      {/* Auto-Fit bounds on load */}
      {showBounds && (
        <FitMapBounds positions={polylinePositions} />
      )}
    </MapContainer>
  );
}
